import {
  GET_SELECT_LIST,
  GET_SELECT_LIST_SUCCESS,
  GET_SELECT_LIST_FAIL,
} from "../actions/selectList";

const initialState = {
  selectListByName: {},
  isLoadingByName: {},
  isLoadedByName: {},
};

export default function selectList(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SELECT_LIST:
      return {
        ...state,
        isLoadingByName: {
          ...state.isLoadingByName,
          [action.additional.name]: true
        },
        isLoadedByName: {
          ...state.isLoadedByName,
          [action.additional.name]: false
        }
      }

    case GET_SELECT_LIST_SUCCESS:
      const name = action.additional.name.split('/')[0];
      const selectList = action.response[name] || [];
      return {
        ...state,
        selectListByName: {
          ...state.selectListByName,
          [action.additional.name]: selectList.map(item => ({
            ...item,
            value: item.id,
            label: item.name,
          }))
        },
        isLoadingByName: {
          ...state.isLoadingByName,
          [action.additional.name]: false
        },
        isLoadedByName: {
          ...state.isLoadedByName,
          [action.additional.name]: true
        }
      }

    case GET_SELECT_LIST_FAIL:
      return {
        ...state,
        isLoadingByName: {
          ...state.isLoadingByName,
          [action.additional.name]: false
        },
        isLoadedByName: {
          ...state.isLoadedByName,
          [action.additional.name]: false
        }
      }

    default:
      return state;
  }
}
